import React, {useState} from 'react';
import * as Icon from "ubs-icons";
import {COLOR} from "../constant";
import {copyToClipboard} from "../common/function";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    TelegramShareButton,
    TelegramIcon
} from "react-share";
import UToastContainer from "../UToastContainer";

const UInviteFriend = React.memo((props) => {
    const [toast, setToast] = useState(false)
    const copyLink = e => {
        setToast(true)
        copyToClipboard(e)
    }

    const handleEmailOnClick = () => {
        window.open(encodeURI(`mailto:?subject=Earn Money with Superworks tool Affiliate Program Subject Here&body=Hi,\n\n Referral Link is ${`${affiliateURL}/?usercode=${referralCode || ''}`}\n\n`), '_blank')
        // window.location.href = encodeURI(`mailto:?subject=Earn Money with UBS tool Affiliate Program Subject Here&body=Hi,\n\nYou Can bla Bla bla "${'test'}" At ${`${affiliateURL}/?usercode=${referralCode || ''}`}\n\n`);
    };

    return (
        <React.Fragment>
            <div className="u_invite-modal u_active">
                <div className="u_invite-modal-overlay"/>
                <div className="u_invite-modal-body">
                    <div className="u_invite-modal-inner">
                        <div className="u_invite-modal-inner-close">
                            <span className="u_close-icon" onClick={() => props.onClose()}><Icon.Close
                                fill={COLOR.u_white}
                                size={14}/></span>
                        </div>
                        <div className="u_invite-modal-inner-header">
                            <div className="u_invite-modal-header-left">
                                <img src="https://files.superworks.com/custom/images/invite-friend.svg"
                                     alt="INVITE YOUR FRIEND"/>
                            </div>
                            <div className="u_invite-modal-header-center">
                                <h6 className="u_color-font">Superworks Referral Bonus - Invite and Earn Yours</h6>
                                <h2 className="u_my-10">Refer <span className="u_color-blue">Superworks</span> and
                                    stand a chance to win a bonus of <span className="u_color-red">₹1,000</span> for
                                    yourself.</h2>
                                <p className="u_text-bold u_color-title">and <span
                                    className="u_color-green">₹10,000</span> for your company.</p>
                            </div>
                            <div className="u_invite-modal-header-right">
                                <div className="u_medal-icon">
                                    <Icon.Medal fill={COLOR.u_orange} size={20}/>
                                </div>
                                <p>WIN</p>
                                <h4 className="u_text-bold">₹1,000</h4>
                            </div>
                        </div>

                        <div className="u_invite-modal-inner-body">
                            <h4 className="u_gift-title">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 20L6 16H14L10 20ZM10 0L14 4H6L10 0ZM10 12C9.46957 12 8.96086 11.7893 8.58579 11.4142C8.21071 11.0391 8 10.5304 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8C10.5304 8 11.0391 8.21071 11.4142 8.58579C11.7893 8.96086 12 9.46957 12 10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12ZM0 10L4 6V14L0 10ZM20 10L16 14V6L20 10Z"
                                        fill="#FF6961"/>
                                </svg>
                                <span className="u_px-15">Avail your gift card in just 3 steps</span>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10 20L6 16H14L10 20ZM10 0L14 4H6L10 0ZM10 12C9.46957 12 8.96086 11.7893 8.58579 11.4142C8.21071 11.0391 8 10.5304 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8C10.5304 8 11.0391 8.21071 11.4142 8.58579C11.7893 8.96086 12 9.46957 12 10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12ZM0 10L4 6V14L0 10ZM20 10L16 14V6L20 10Z"
                                        fill="#FF6961"/>
                                </svg>
                            </h4>

                            {/* steps section */}
                            <div className="u_invite-friend-steps">
                                <div className="u_steps-inner">
                                    <span className="u_mb-10 u_block"><Icon.Checked fill={COLOR.u_green}
                                                                                    size={40}/></span>
                                    <p className="u_orange u_mb-15">Step 1</p>
                                    <h4>Copy and Share your unique link with <br/>your friends and other contacts.</h4>
                                </div>
                                <div className="u_steps-inner">
                                    <span className="u_mb-10 u_block"><Icon.Checked fill={COLOR.u_green}
                                                                                    size={40}/></span>
                                    <p className="u_orange u_mb-15">Step 2</p>
                                    <h4>Let them purchase Superworks from <br/> your referral link.</h4>
                                </div>
                                <div className="u_steps-inner">
                                    <span className="u_mb-10 u_block"><Icon.Checked fill={COLOR.u_green}
                                                                                    size={40}/></span>
                                    <p className="u_orange u_mb-15">Step 3</p>
                                    <h4>For every purchase, you and your company
                                        will <br/>win <strong>₹1000</strong> and <strong>₹10000</strong> respectively.
                                    </h4>
                                </div>
                            </div>

                            {/* link section */}
                            <div className="u_invite-link-section">
                                <div className="u_invite-link">
                                    <label className="u_label u_mb-5">Your Unique Link:</label>

                                    <div className="u_invite-link-input">
                                        <p>{`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}</p>
                                        <span
                                            onClick={() => copyLink(`${props.affiliateURL}/?usercode=${props.referralCode || ''}`)}><Icon.Copy
                                            className="u_mr-5" fill={COLOR.u_blue}
                                            size={16}/> Copy</span>
                                    </div>
                                </div>
                                <div className="u_social-link">
                                    <label className="u_label u_mb-5">Share Via:</label>
                                    <div className="u_flex u_align-center">
                                        <FacebookShareButton
                                            url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                            quote="Earn Money with Superworks tool Affiliate Program"
                                            className="u_social-link-icons"
                                        >
                                            <FacebookIcon size={32} round/>
                                        </FacebookShareButton>


                                        <TwitterShareButton
                                            url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                            quote="Earn Money with Superworks tool Affiliate Program"
                                            className="u_social-link-icons"
                                        >
                                            <TwitterIcon size={32} round/>
                                        </TwitterShareButton>


                                        <WhatsappShareButton
                                            url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                            title="Earn Money with Superworks tool Affiliate Program"
                                            separator=":: "
                                            className="u_social-link-icons"
                                        >
                                            <WhatsappIcon size={32} round/>
                                        </WhatsappShareButton>

                                        <LinkedinShareButton url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                                             className="u_social-link-icons">
                                            <LinkedinIcon size={32} round/>
                                        </LinkedinShareButton>

                                        <TelegramShareButton
                                            url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                            title="Earn Money with Superworks tool Affiliate Program"
                                            className="u_social-link-icons"
                                        >
                                            <TelegramIcon size={32} round />
                                        </TelegramShareButton>

                                        {/*<EmailShareButton
                                            // url={`${props.affiliateURL}/?usercode=${props.referralCode || ''}`}
                                            // subject="Earn Money with UBS tool Affiliate Program"
                                            // body="Ultimate Business System"
                                            className="u_social-link-icons"
                                            onClick={handleEmailOnClick}
                                        >
                                            <EmailIcon size={32} round/>
                                        </EmailShareButton>*/}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="u_invite-modal-inner-footer">
                            <p>You can avail bonus only when the onboarded company starts paying Superworks. The bonus will be
                                offered only once per referred company.</p>
                        </div>
                    </div>
                </div>
            </div>
            {toast && <UToastContainer msg="Link Copied Successfully to Clipboard!" close={() => setToast(false)} />}
        </React.Fragment>
    );
});

export default UInviteFriend;
